import omit from "lodash/omit";
import snakecaseKeys from "snakecase-keys";

import { filtersToGet } from "@/utils/metadata";
import { camelizeKeys } from "@/utils/utilsGrpcRest";
import { atmoClient } from "@/setup/clients/atmoClient";

const UUID_KEY =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

const CLIENT_ONLY_KEYS = [
  "date",
  "eventTypes",
  "formTypes",
  "formFieldToEvent",
  "premix",
];

const toBody = (recordBook) => {
  const body = omit(recordBook, CLIENT_ONLY_KEYS);
  if ("recordBlocks" in body) body.recordBlocks = [];
  return snakecaseKeys(body, { exclude: [UUID_KEY] });
};

const RecordBookClient = {
  listAll: async (filters, config) => {
    let url = "recordbooks/";
    if (Object.keys(filters)) {
      url += filtersToGet(filters);
    }
    const response = await atmoClient.get(url, config);
    return camelizeKeys(response.data);
  },
  retrieve: async (uuid, config) => {
    const response = await atmoClient.get(`recordbooks/${uuid}/`, config);
    return camelizeKeys(response.data);
  },
  create: async (recordBook, config) => {
    const response = await atmoClient.post(
      "recordbooks/",
      toBody({ recordBlocks: [], ...recordBook }),
      config
    );
    return camelizeKeys(response.data);
  },

  update: async (recordBook, _uuid, config) => {
    const response = await atmoClient.put(
      `recordbooks/${recordBook.uuid}/`,
      toBody({ recordBlocks: [], ...recordBook }),
      config
    );
    return camelizeKeys(response.data);
  },

  partialUpdate: async (recordBook, _uuid, config) => {
    const response = await atmoClient.patch(
      `recordbooks/${recordBook.uuid}/`,
      toBody(recordBook),
      config
    );
    return camelizeKeys(response.data);
  },

  bulkArchive: async (uuids, isArchived) => {
    await atmoClient.post("recordbooks/bulk_archive/", {
      uuids,
      is_archived: isArchived,
    });
  },

  destroy: async (uuid) => {
    console.warn("RecordBookClient.destroy is not implemented", uuid);
  },
};

export default RecordBookClient;
